import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import * as React from 'react'
import { ServiceLocationLink } from '@user/components/RequirementsToClose/ClosingRequirementTables/AppointmentsTable/columnHelpers'

interface Prop {
  label: string
  value: string
  linkId?: string
}

export const NoteCardDetailItem = (props: Prop) => {
  const { label, value, linkId } = props

  return (
    <Stack
      direction="row"
      gap={0.5}
      width="100%"
      alignItems="flex-start"
      pl={0.8}
    >
      <Typography
        variant="subtitle2"
        color="#0E283FD8"
        sx={{ whiteSpace: 'nowrap' }}
      >
        {label}:
      </Typography>
      {linkId ? (
        <ServiceLocationLink
          locationId={linkId}
          locationCode={value}
          icon="/static-assets/icons/arrow-northeast-outlined.svg"
        />
      ) : (
        <Typography
          variant="body2"
          color="#0E283FD8"
          sx={{ mt: '1px', wordBreak: 'break-all' }}
        >
          {value}
        </Typography>
      )}
    </Stack>
  )
}
